module.exports = __webpack_public_path__ + "static/Popshows_Logo-3054f1a1f298c52deca33287a8487033.png";